var getIconAssetColor = function getIconAssetColor(disabled, color) {
  if (disabled) return 'base.disabled';
  if (color) return color;
  return 'base.default';
};
var getImageBorderRadius = function getImageBorderRadius(heightNumber) {
  if (heightNumber < 16) return '2';
  if (heightNumber < 32) return '4';
  if (heightNumber < 64) return '8';
  return '16';
};

export { getIconAssetColor, getImageBorderRadius };
//# sourceMappingURL=ListItem.mappers.js.map
